import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import useSWR from 'swr';
import styled from '@emotion/styled';

import { ADMIN_ACCESS_TOKEN_KEY } from '../../../App';
import { DataRangeFirstStyle } from '@pages/Log/Admin';
import { Body } from '@components/templates';
import { Filters, Worklist, Pagination } from '@components/organisms';
import { DEFAULT_COUNT_PER_PAGE, DEFAULT_CURRENT_PAGE } from '@components/organisms/Table/Pagination';

const UserLogPage = () => {
  const [accessToken, setAccessToken] = useState('');
  const [valueState, setValueState] = useState({
    searchKey: '',
    searchKeyword: '',
    dateRange: { startDate: '', endDate: '' },
  });
  const [pageConditionsValue, setPageConditionsValue] = useState({
    countPerPage: DEFAULT_COUNT_PER_PAGE,
    currentPage: DEFAULT_CURRENT_PAGE,
    totalCount: 1,
    'order.name': 'id',
    'order.sort': 'DESC',
  });
  const { countPerPage, currentPage } = pageConditionsValue;
  const { searchKey, searchKeyword, dateRange } = valueState;

  useEffect(() => {
    const newToken = localStorage.getItem(ADMIN_ACCESS_TOKEN_KEY);
    if (newToken) {
      setAccessToken(newToken);
    }
  }, []);

  useEffect(() => {
    if (valueState)
      setPageConditionsValue((prev) => ({
        ...prev,
        currentPage: DEFAULT_CURRENT_PAGE,
      }));
  }, [valueState]);

  const url = `api/log/user/history?countPerPage=${countPerPage}&currentPage=${currentPage}&searchType=${
    searchKey || ''
  }&searchValue=${searchKeyword || ''}&fromDate=${dateRange.startDate || ''}&toDate=${dateRange.endDate || ''}`;

  const { data, error } = useSWR(!!accessToken.length ? [{ url, accessToken }] : null);

  if (error) return <div>failed to load</div>;
  if (!data) return <div>loading...</div>;
  if (!data.result) {
    if (data.code === 'UNAUTHORIZED') return <Navigate to={'/'} replace={true} />;
    return (
      <div>
        <>Error is {data.code || 'unknown'} </>
      </div>
    );
  }

  return (
    <>
      <label>User Log (Recent Access Data of Product view)</label>
      <UserLogBody data-page-type={'table-only'}>
        <Filters
          filterKey={'log'}
          searchConditions={valueState}
          setSearchConditions={setValueState}
          styles={DataRangeFirstStyle}
        />
        <Worklist
          headers={[
            { label: 'Id', data_label: 'id' },
            { label: 'Company Id', data_label: 'companyId' },
            { label: 'Menu', data_label: 'menu' },
            { label: 'User ID', data_label: 'userId' },
            { label: 'First Name', data_label: 'firstName' },
            { label: 'Last Name', data_label: 'lastName' },
            { label: 'IP Address', data_label: 'ipAddress' },
            { label: 'Privacy', data_label: 'privacy' },
            { label: 'Method', data_label: 'action' },
            { label: 'Url', data_label: 'url' },
            { label: 'Created Datetime', data_label: 'createdDatetime' },
          ]}
          data={{ dataArray: [...(data.result?.results || [])] }}
          customColumn={{
            userId: (row) => (
              <>
                {row.userId && row.userId.substring(0, 2)}
                {row.userId && Array.from({ length: row.userId.length - 2 }).map(() => '*')}
              </>
            ),
            lastName: (row) => (
              <>
                {row.lastName && row.lastName.substring(0, 2)}
                {row.lastName && Array.from({ length: row.lastName.length - 2 }).map(() => '*')}
              </>
            ),
            privacy: (row) => <>{row.privacy ? '\u2713' : ''} </>,
          }}
        />

        <Pagination conditions={data.result?.condition ?? pageConditionsValue} setConditions={setPageConditionsValue} />
      </UserLogBody>
    </>
  );
};

const UserLogBody = styled(Body)`
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;
  & > div:nth-of-type(1) {
    margin-left: 0;
  }
`;

export default UserLogPage;
